import './searchbox.css'
import closeicon from '../../image/close.png'
import errorimage from '../../image/error.png'
import { useEffect, useState } from 'react';
export default function Searchbox(props) {
    const [products, setProducts] = useState([]);
    const [loadingimage , setLoadingimage] = useState(true)
    function closesearch() {
        props.setOpensearch(false)
    }

    useEffect(() => {
        fetch('http://185.164.73.170:5000/products')
            .then(response => response.json())
            .then(data => setProducts(data))
            .catch(error => console.error('Error fetching products:', error));
    }, []);
    const getimage = (p) => {
        try{
            return `http://dl.mahoganyacademy.de/productimage/${p.code}.png`;
        } catch (error) {
            return require(`../../logo/tehranmulogo.jpg`);
        }
    }
    const filtersearch = products.filter(item => {
        const namesearch = item.name.toLowerCase();
        const valuesearch = props.searchvalue;
        return valuesearch && namesearch.includes(valuesearch)
    })
    return (
        <div className='searchbox' style={props.opensearch === true ? { scale: '1' } : { scale: '0' }}>
            <img onClick={closesearch} src={closeicon} alt='clousesearch'></img>
            <ul className='products'>
                {filtersearch.length > 0 ? (
                    filtersearch.map(p => (
                        <li key={p.id}>
                        <div className='productbox'>
                            <div className='productimage'>
                            <div className='spinner' style={{display: loadingimage === true ? 'block' : 'none'}}></div>
                                <img style={{display: loadingimage === true ? 'none' : 'block'}} onLoad={() => setTimeout(() => {setLoadingimage(false)}, 2000)} src={getimage(p)} onError={(e) => { e.target.src = errorimage }} alt={p.name}></img>
                            </div>
                            <div className='productdetails'>
                                <h4>{p.name}</h4>
                                <p>برند : {p.brand}</p>
                                <p>مقدار : {p.description}</p>
                            </div>
                        </div>
                    </li>
                    ))
                ) : (
                    <p className='errorsearch'>محصولی پیدا نشد</p>
                )}
            </ul>
        </div>
    )
}